import { useSuppressionListsCRUDActions } from '@mm/state/actions/SuppressionListsCRUDActions';
import { selectHubspotSuppressionList } from '@mm/state/modules/suppressionListsTableState/selectors';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { Switch } from 'antd';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styles from './HubspotIntegrations.module.css';

type Props = {
  tokenId: number;
};

export const HubspotSuppressionSetup = ({ tokenId }: Props) => {
  const activeFbPageId = useSelector(activeFacebookPageIdSelector);
  const { update, create, retrieveAll } = useSuppressionListsCRUDActions();
  const suppressions = useSelector(selectHubspotSuppressionList);
  const suppression = suppressions[0];

  const updateSuppression = (enabled: boolean) => {
    if (suppression?.id) {
      update(activeFbPageId, {
        id: suppression.id,
        enabled,
        sourceId: suppression.sourceId,
        sourceKind: 'hubspot',
      });
    } else {
      create(activeFbPageId, {
        enabled,
        sourceId: tokenId,
        sourceKind: 'hubspot',
      });
    }
  };

  useEffect(() => {
    if (suppressions.length === 0) {
      retrieveAll(activeFbPageId);
    }
  }, []);

  return (
    <div className={classNames(styles.box, styles.suppressionBox)}>
      <div className={classNames(styles.boxWithHelp)}>
        <div className={styles.boxContent}>
          <div className={classNames(styles.heading, styles.headingWithSwitch)}>
            Automatically suppress Hubspot contacts
            <Switch
              key={`switch-suppression-${
                suppression?.enabled ? 'enabled' : 'disabled'
              }`}
              defaultChecked={!!suppression?.enabled}
              checkedChildren="Yes"
              unCheckedChildren="No"
              className={styles.switch}
              onChange={ok => updateSuppression(ok)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
